/**
 * Calculates the total CO2e content based on provided ingredients.
 */
export function calculateTotalCo2e(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalCo2e = [...ingredients].reduce(addCo2e, 0);

  return Math.round(totalCo2e);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.co2eKg !== 'number';
}

function addCo2e(total: number, ingredient: Ingredient) {
  const co2e = typeof ingredient.co2eKg === 'number' ? ingredient.co2eKg : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + co2e * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredient = { co2eKg: number | null; quantity?: number };
type Ingredients = Ingredient[] | readonly Ingredient[];
